// @ts-nocheck
import Vue from "vue";
import Vuex from "vuex";
import Cookies from "js-cookie";
import routerData from "./modules/routerData";
import role from "./modules/role";
import layout from "./modules/layout/index";
import cn from "../i18n/lang/cn";

Vue.use(Vuex);

const store = new Vuex.Store({
  state: {
    token: Cookies.get("token"),
    userInfo: JSON.parse(localStorage.getItem("userInfo")),
    excludedComponents: "",
    oldTableData: []
  },
  mutations: {
    // 保存用户信息
    saveUserInfo(state, userInfo) {
      // 先把数据存储到本地
      localStorage.setItem("userInfo", JSON.stringify(userInfo));
      //保存用户信息
      state.userInfo = userInfo;
      if (userInfo.mapInfo.menusFunction) {
        userInfo.mapInfo.menusFunction.forEach(el => {
          if (el.childNodes && el.childNodes.length != 0) {
            el.childNodes.forEach(item => {
              cn.routeName[item.fnCode] = item.fnName;
            });
          }
        });
      }
    },
    setToken(state, token) {
      state.token = token;
      Cookies.set("token", token, { expires: 1 / 24 });
    },
    // 添加需要刷新的组件页面、
    addExcludedComponents(state, data) {
      state.excludedComponents = data;
    },
    // 添加不需要刷新的组件页面、
    addIncludeComponents(state, data) {
      state.excludedComponents = data;
    }
  },
  actions: {
    setToken({ commit }, token) {
      return new Promise((resolve, reject) => {
        commit("setToken", token);
        resolve();
      });
    }
  },
  getters: {
    addRouters: state => state.routerData.addRouters,
    token: state => state.token,
    info: state => state.role.info,
    routers: state => state.routerData.routers,
    logoShow: state => state.layout.logoShow,
    isCollapse: state => state.layout.isCollapse,
    uniquerouter: state => state.layout.uniquerouter,
    tabnavBox: state => state.layout.tabnavBox,
    visible: state => state.layout.visible,
    left: state => state.layout.left,
    top: state => state.layout.top,
    rightNav: state => state.layout.rightNav
  },
  modules: {
    routerData,
    role,
    layout
  }
});

export default store;



// WEBPACK FOOTER //
// ./src/vuex/index.js